//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
import { useState, useEffect, createElement } from "react"
import "98.css";
//import Typewriter from "typewriter-effect";
//import { setSelectionRange } from '@testing-library/user-event/dist/utils';

export default function Terminal({onClose}) {

    useEffect(() => {
        //clearActiveWindow();
        //document.querySelector('.window-container').append(document.querySelector('.window[data-name="Terminal"]'));
        
        return () => {
            //console.log('Component will unmount');
        };
    }, []);

    const [inputList, setInputList] = useState([
        { field: '' }
    ]);

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function handleKeyDown(e) {
        //console.log(e.key)
        if (e.key === 'Enter') {
            var recentInput = document.querySelectorAll('input.terminal-input-field')[document.querySelectorAll('input.terminal-input-field').length-1];
            if (recentInput.value === 'cls') {
                document.querySelector('.window[data-name="Terminal"] .window-body div').innerHTML = '';
            } else if (recentInput.value.indexOf('echo') > -1) {
                var echo = recentInput.value.replaceAll('echo ','')
                recentInput.insertAdjacentHTML('afterend', '<p class="echo-response">' + echo + '</p><br>');
            } else if (recentInput.value !== '') {
                var text = recentInput.value;
                recentInput.insertAdjacentHTML('afterend', '<p class="echo-response">"' + text + '" is not recognized as an internal or external command, operable program or batch file.</p><br>');
            }
            
            handleInputAdd();
            setTimeout(function() {
                var newElement = document.querySelectorAll('input.terminal-input-field')[document.querySelectorAll('input.terminal-input-field').length-1];
                newElement.focus();
            }, 50);
        }
    }

    const handleInputAdd = () => {
        setInputList([...inputList, { field: '' }])
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        //console.log(selector)
        //console.log(selector.nodeName)

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        //Toolbar tab buttons
        if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
            dataName = selector.getAttribute('data-name');
            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            selector = selector.closest('.window');
            dataName = selector.getAttribute('data-name');
        }

        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    return (

        <div className="window active" data-name="Terminal" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">
                    <div className="title-bar-logo"><img src="/images/social_logos_cropped/msdos.png" alt="MSDOS icon"/></div>
                    MS-DOS Prompt
                </div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Terminal"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="Terminal"></button>
                </div>
            </div>

            <div className="window-body">

                {/* <p>Microscoft(R) Windows 98</p> */}
                <p>Megahard(R) Windows 98</p>
                <p style={{marginLeft: "10px"}}>(C)Copyright Be Lucky Corp 2024-2025</p>
                <br></br>
                <div>
                    {inputList.map((singleInput, index) => (
                        <p key={index}>C:\&gt;&nbsp;<input className="terminal-input-field" type="text" tabIndex={-1} onKeyDown={handleKeyDown} autoFocus></input></p>
                    ))}

                    {/* <Typewriter options = {{
                        strings: ['Wake up, friend...', 'The Matrix has you...', 'Follow the white rabbit.'],
                        autoStart: true,
                        loop: true,
                        cursor: '',
                        pauseFor: 2000,
                        delay: 50,
                        deleteSpeed: 50
                    }} /> */}

                </div>

            </div>

        </div>

         
    )

}